
export const tamannosLienzo={
    HD:[Number(1280),Number(720)],
    FullHD:[Number(1920),Number(1080)],
    CuatroKCine:[Number(4096),Number(2160)]
}